import React, { CSSProperties, ReactNode } from 'react';
import { Badge } from '@/components/ui/badge';
import { BaseTooltip } from '@/components';
import { cn } from '@/lib/utils';

export interface OverflowBadgeProps {
  count: number;
  tooltipContent: ReactNode;
  className?: string;
  style?: CSSProperties;
}

export const OverflowBadge = ({ count, tooltipContent, className, style }: OverflowBadgeProps) => {
  if (count <= 0) return null;

  return (
    <BaseTooltip content={tooltipContent}>
      <Badge variant="secondary" className={cn('bg-neutral-50 hover:bg-neutral-50 shrink-0', className)} style={style}>
        +{count}
      </Badge>
    </BaseTooltip>
  );
};
